<template>
  <nav id="gNav">
    <ul>
      <li>
        <router-link tag="a" data-nav="top" to="/">
          <p>TOP</p>
        </router-link>
      </li>
      <li>
        <router-link tag="a" data-nav="service" to="/service/">
          <p>SERVICE</p>
        </router-link>
      </li>
      <li>
        <router-link tag="a" data-nav="partners" to="/partners/">
          <p>PARTNERS</p>
        </router-link>
      </li>
      <li>
        <router-link tag="a" data-nav="contact" to="/contact/">
          <p>CONTACT</p>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'gNav'
}
</script>



// WEBPACK FOOTER //
// src/components/nav.vue